export default {
  app: {
    name: 'CargoWare X',
    description: '租户门户系统'
  },
  common: {
    // 操作按钮
    create: '新增',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    clear: '清空',
    refresh: '刷新',
    export: '导出',
    import: '导入',
    upload: '上传',
    download: '下载',
    view: '查看',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    close: '关闭',
    open: '打开',
    expand: '展开',
    collapse: '收起',
    copy: '复制',
    detail: '详情',
    more: '更多',
    add: '添加',

    // 状态
    statusLabel: '状态',
    active: '启用',
    inactive: '禁用',
    enabled: '已启用',
    disabled: '已禁用',
    normal: '正常',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息',

    // 时间
    createTime: '创建时间',
    updateTime: '更新时间',
    lastLogin: '最后登录',

    // 分页
    total: '共',
    items: '条',
    page: '页',
    pageSize: '每页',

    // 其他
    operation: '操作',
    actions: '操作',
    remark: '备注',
    description: '描述',
    name: '名称',
    code: '代码',
    sort: '排序',
    yes: '是',
    no: '否',
    ok: '确定',
    noData: '暂无数据',

    // 查询操作符
    queryOperator: {
      eq: '等于',
      ne: '不等于',
      like: '包含',
      not_like: '不包含',
      in: '批量',
      not_in: '不在范围内',
      is_null: '为空',
      is_not_null: '不为空',
      gt: '大于',
      ge: '大于等于',
      lt: '小于',
      le: '小于等于',
      between: '范围',
      not_between: '不在范围内',
      date_shortcut: '日期快捷操作'
    },

    // 日期快捷操作
    dateShortcut: {
      this_week: '本周',
      last_week: '上周',
      next_week: '下周',
      this_month: '本月',
      last_month: '上月',
      next_month: '下月',
      this_year: '今年',
      last_year: '去年',
      next_year: '明年',
      today: '今天',
      yesterday: '昨天',
      tomorrow: '明天',
      last_7_days: '过去7天',
      last_30_days: '过去30天',
      last_90_days: '过去90天'
    },

    // 语言设置
    language: {
      current: '当前语言',
      switch: '切换语言',
      chinese: '简体中文',
      english: 'English',
      switchSuccess: '语言切换成功',
      switchError: '语言切换失败'
    },

    // 主题设置
    theme: {
      light: '浅色主题',
      dark: '深色主题',
      auto: '跟随系统'
    }
  },
  nav: {
    home: '首页',
    dashboard: '仪表盘',
    profile: '个人资料',
    settings: '设置',
    logout: '退出登录'
  },
  auth: {
    login: '登录',
    logout: '退出',
    username: '用户名',
    password: '密码',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    logoutSuccess: '退出成功',

    // 租户选择弹窗
    tenantSelect: {
      title: '选择租户',
      desc: '请选择您要登录的企业租户',
      label: '选择企业',
      selectPlaceholder: '请选择企业租户',
      cancel: '取消',
      confirm: '确认',
      error: '请选择企业租户'
    },

    // 租户登录页面
    tenantLogin: {
      title: '智慧物流控制塔',
      subtitle: '全球物流智能管理平台',
      backToHome: '返回首页',

      // 登录相关
      login: {
        welcome: '欢迎回来',
        description: '登录您的账户，开启智慧物流之旅',
        globalNetwork: '全球网络',
        networkDescription: '连接全球200+国家和地区，提供一站式物流解决方案',
        passwordLogin: '密码登录',
        codeLogin: '验证码登录',
        accountLabel: '邮箱或手机号',
        accountPlaceholder: '请输入邮箱或手机号',
        phoneLabel: '手机号或邮箱',
        phonePlaceholder: '请输入手机号或邮箱',
        passwordLabel: '密码',
        passwordPlaceholder: '请输入密码',
        codeLabel: '验证码',
        codePlaceholder: '请输入验证码',
        rememberMe: '记住我',
        forgotPassword: '忘记密码？',
        loginButton: '立即登录',
        loggingIn: '登录中...',
        sendCode: '发送验证码',
        resendAfter: 's后重发',
        otherMethods: '其他登录方式'
      },

      // 注册相关
      register: {
        title: '创建账户',
        description: '注册成为我们的用户，享受专业的物流服务',
        joinUs: '加入我们',
        joinDescription: '开启您的智慧物流之旅，体验高效便捷的货运管理',
        usernameLabel: '用户名',
        usernamePlaceholder: '请输入用户名',
        phoneLabel: '手机号',
        phonePlaceholder: '请输入手机号',
        phoneCodeLabel: '手机验证码',
        phoneCodePlaceholder: '请输入验证码',
        emailLabel: '邮箱（可选）',
        emailPlaceholder: '请输入邮箱（可选）',
        passwordLabel: '设置密码',
        passwordPlaceholder: '至少6位密码',
        confirmPasswordLabel: '确认密码',
        confirmPasswordPlaceholder: '请再次输入密码',
        agreementPrefix: '我已阅读并同意',
        userAgreement: '《用户协议》',
        and: '和',
        privacyPolicy: '《隐私政策》',
        registerButton: '立即注册',
        registering: '注册中...',
        sendCode: '发送验证码',
        resendAfter: 's后重发',
        enterpriseUserTip: '企业用户？',
        enterpriseUserDesc: '请联系您的企业管理员或',
        staffLogin: '使用员工通道登录'
      },

      // 切换相关
      switch: {
        noAccount: '还没有账号？',
        hasAccount: '已有账号？',
        register: '立即注册',
        login: '立即登录'
      },

      // 忘记密码
      forgotPassword: {
        title: '重置密码',
        description: '通过验证码重置您的账户密码',
        accountLabel: '账户信息',
        accountPlaceholder: '请输入手机号或邮箱',
        codeLabel: '验证码',
        codePlaceholder: '请输入6位验证码',
        newPasswordLabel: '新密码',
        newPasswordPlaceholder: '请输入新密码（至少6位）',
        confirmPasswordLabel: '确认新密码',
        confirmPasswordPlaceholder: '请再次输入新密码',
        sendCode: '发送验证码',
        resendAfter: 's后重发',
        cancel: '取消',
        confirm: '确认重置',
        resetting: '重置中...',
        successMessage: '密码重置成功！',
        failedMessage: '密码重置失败，请重试'
      },

      // 账号已存在提醒
      accountExists: {
        title: '账号已注册',
        description: '该账号已在系统中注册',
        mainTitle: '该账号已存在',
        content: '您输入的手机号或邮箱已经注册过账号，请直接登录或使用其他账号注册。',
        tipTitle: '温馨提示',
        tipContent: '如果忘记密码，可以在登录页面使用"忘记密码"功能找回。',
        cancel: '继续注册',
        goToLogin: '去登录'
      },

      // 消息提示
      messages: {
        loginSuccess: '登录成功！',
        loginFailed: '登录失败，请检查账号密码',
        registerSuccess: '注册成功！',
        registerFailed: '注册失败，请重试',
        codeSent: '验证码已发送',
        codeFailed: '验证码发送失败',
        enterAccountFirst: '请先输入账号',
        enterPhoneFirst: '请先输入手机号',
        enterValidPhone: '请输入有效的手机号',
        passwordMismatch: '两次输入的密码不一致',
        personalLoginSuccess: '个人账号登录成功',
        enterpriseLoginSuccess: '企业账号登录成功',
        enterAccount: '请输入账号',
        enterPassword: '请输入密码',
        enterCode: '请输入验证码',
        enterUsername: '请输入用户名',
        enterValidPhoneNumber: '请输入有效的手机号',
        passwordMinLength: '密码至少6位',
        passwordNotMatch: '两次输入的密码不一致',
        agreeToTerms: '请同意用户协议和隐私政策',
        enterPhoneOrEmail: '请先输入手机号或邮箱',
        codeSentSuccess: '验证码已发送 📱',
        noDomainConfigured: '跳转失败，请重试，当前租户没有配置域名'
      }
    },

    // 策略弹窗
    policy: {
      agreement: {
        title: '用户协议',
        heading: '用户协议',
        welcome: '欢迎使用我们的智慧物流平台。请仔细阅读以下用户协议条款。',
        content: '通过注册和使用本平台，您同意遵守本协议的所有条款和条件。'
      },
      privacy: {
        title: '隐私政策',
        heading: '隐私政策',
        welcome: '我们非常重视您的隐私保护。本隐私政策说明了我们如何收集、使用和保护您的个人信息。',
        content: '我们承诺保护您的个人信息安全，不会未经您的同意向第三方披露您的信息。'
      },
      closeButton: '我知道了'
    },

    // 门户页头
    portalHeader: {
      backToHome: '回到首页',
      loginRegister: '登录/注册'
    },

    // SSO 授权登录
    sso: {
      // 授权页面
      authLogin: '授权登录',
      authDescription: '使用 {provider} 账号授权登录',
      usernameLabel: '账号',
      usernamePlaceholder: '请输入账号',
      usernameRequired: '请输入账号',
      passwordLabel: '密码',
      passwordPlaceholder: '请输入密码',
      passwordRequired: '请输入密码',
      passwordError: '密码错误',
      authButton: '立即授权',
      authorizing: '授权中...',
      authAgreement: '授权登录即表示同意 {provider} 的服务协议',
      back: '返回',
      backToLogin: '返回登录',

      // 租户选择弹窗
      selectTenant: '选择租户',
      selectTenantDesc: '请选择您要登录的企业租户',
      tenantLabel: '选择企业',
      tenantPlaceholder: '请输入企业名称或ID进行搜索',
      noMatchResult: '没有匹配的结果',
      cancel: '取消',
      confirmBind: '确认绑定',
      selectTenantError: '请选择企业租户',

      // 用户验证弹窗
      verifyUser: '验证用户',
      verifyUserDesc: '请选择用户并输入密码进行验证',
      selectUserPlaceholder: '请选择用户',
      verifyLogin: '验证并登录',

      // 消息提示
      loginSuccess: '登录成功',
      loginFailed: '登录失败，请检查账号密码'
    }
  },

  // 系统相关
  system: {
    name: '租户门户系统',
    brand: 'CargoWare X',
    mode: '运营',
    backToPortal: '返回门户首页'
  },

  // 表单相关
  form: {
    required: '此项为必填项',
    invalid: '输入格式不正确',
    tooShort: '输入内容过短',
    tooLong: '输入内容过长',
    pleaseSelect: '请选择',
    pleaseInput: '请输入'
  },

  // 消息提示
  message: {
    refreshSuccess: '刷新成功',
    actionSuccess: '操作成功',
    deleteSuccess: '删除成功',
    developmentInProgress: '功能开发中...',
    logoutSuccess: '退出登录成功',
    logoutError: '退出登录失败'
  },

  // 确认信息
  confirmMessages: {
    delete: '确定要删除这条记录吗？',
    logout: '确认退出',
    logoutMessage: '确定要退出登录吗？'
  },

// 产品演示表单
  demoForm: {
    title: '申请产品演示',
    subtitle: '填写信息，我们将为您提供专业的产品演示',
    name: '姓名',
    namePlaceholder: '请输入您的姓名',
    company: '公司',
    companyPlaceholder: '请输入公司名称',
    phone: '电话',
    phonePlaceholder: '请输入联系电话',
    email: '邮箱',
    emailPlaceholder: '请输入邮箱地址',
    privacyNotice: '我们承诺保护您的隐私，您的信息仅用于产品演示预约，不会用于其他商业用途。',
    submitButton: '立即申请演示',
    cancelButton: '取消',
    submitSuccess: '提交成功！我们会尽快与您联系。',
    submitFailed: '提交失败，请重试',
    validation: {
      required: '请填写此字段。',
      nameRequired: '请输入您的姓名',
      companyRequired: '请输入公司名称',
      phoneRequired: '请输入联系电话',
      emailRequired: '请输入邮箱地址',
      emailInvalid: '请输入有效的邮箱地址'
    }
  },

  // 门户页面
  portal: {
    hero: {
      welcome: '您好！我是{siteName}的AI智能助手，有任何关于运价、订单操作或货物跟踪的问题，都可以向我咨询。',
      defaultSlogan: 'AI赋能的数字化货代平台',
      defaultDescription: '智能AI助手实时解答您的运价、航线和货物跟踪问题，让物流管理变得简单高效。',
      stats: {
        reliability: '服务可靠性',
        routes: '全球航线',
        users: '活跃用户'
      },
      chat: {
        placeholder: '输入您的问题...',
        aiName: 'AI智能助手',
        status: '在线为您服务 | 实时响应'
      }
    }
  }
}
